import { createSelector } from '@ngrx/store'
import { AppState } from '../../app.state'
import { QuadState, SeoState } from './quadList.reducer';


export const selectQuadSlice = (state: AppState) => state.quadSlice;



export const selectedQuad = createSelector(
    selectQuadSlice,
    (state: QuadState) => {
        return state.selectedQuadUUID
    }
)


export const selectQuadItemList = createSelector(
    selectQuadSlice,
    (state: QuadState) => {
        return state.itemList
    }
)
